module.exports = __webpack_public_path__ + "static/img/showroom9.20bbb1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom9.png
// module id = ChkL
// module chunks = 2